
import { component } from '@/helpers/vueTyped';
import store from '@/store';
import WithNavigateOnFocus from '@/components/Helpers/WithNavigateOnFocus.vue';

interface MenuItemProps {
  iconActive: string;
  iconInactive: string;
  route: string;
  label: string;
}

export default component<MenuItemProps>()({
  name: 'MenuItem',

  props: {
    iconActive: {},
    iconInactive: {},
    route: {},
    label: {},
  },

  computed: {
    drawerOpen(): boolean { return store.state.drawerOpen; },
    isSelected(): boolean {
      return store.state.navigationState.sport == null ?
        this.route === '/' : this.route.includes(store.state.navigationState.sport);
    },
  },

  render() {
    return (
      <WithNavigateOnFocus
        disabled={!this.drawerOpen}
        attrs={this.$attrs}
        to={this.route}
        class='menu-item'
      >
        <div class='icon-div'>
          <img class='icon' src={this.isSelected ? this.iconActive : this.iconInactive} />
        </div>
        <div class='label-div'>{this.label}</div>
      </WithNavigateOnFocus>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-ab2cd232/MenuItem.vue" });